var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    alt: "Clock Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,10.4V7.8h-2.5v2.6C13.1,11,8.6,15.8,8.6,21.6c0,2.7,0.9,5.1,2.5,7.1l-1.8,1.8l1.8,1.8l1.8-1.8 c1.9,1.6,4.4,2.5,7.1,2.5s5.1-0.9,7.1-2.5l1.8,1.8l1.8-1.8l-1.8-1.8c1.6-1.9,2.5-4.4,2.5-7.1C31.3,15.8,26.9,11,21.2,10.4z M20,30.4c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8S24.8,30.4,20,30.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.2,15.3 18.7,15.3 18.7,22.2 22.6,26.1 24.3,24.3 21.2,21.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.4968 10.3092)",
    className: "st0",
    width: 6.3,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 7.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1.2835 24.1589)",
    className: "st0",
    width: 2.5,
    height: 6.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.976f676b.svg";
export { ForwardRef as ReactComponent };